// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__LRM_G","containerItemsCenter":"Skeleton_containerItemsCenter__185z5"};